/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Icon } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import React, { useState } from 'react';
import descriptors from '../../../locales/en-US/descriptors';
import { POLLING_MILLI_SECONDS } from '../../shared/Utils/Constants';
import { IProgressTab } from '../IUtilityService';
// in seconds
const timerDuration = 5;
//in milliseconds
const timerCountReducer = POLLING_MILLI_SECONDS;
function ProgressTab(props: IProgressTab) {
  const { closeModal } = props;
  const [redirectSeconds, setRedirectSeconds] = useState(timerDuration);
  const startTimer = () => {
    let timer = setTimeout(() => {
      if (redirectSeconds === 0) {
        clearTimeout(timer);
        closeModal();
      } else {
        setRedirectSeconds(redirectSeconds - 1);
      }
    }, timerCountReducer);
  };
  startTimer();
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  return (
    <div className="loading-status">
      <div>
        <div className="align-center">
          <Button
            className="upload-modal-loading"
            loading={true}
            disabled={true}
            content="Loading"
          />
        </div>
        {props.utilityType !== 'Manual' && (
          <div className="align-center f-20">{t(d.VERIFICATIONINPROCESS)}</div>
        )}
        {props.utilityType !== 'Manual' && (
          <div className="align-center pt-10">{t(d.VERIFICATIONMSSG1)}</div>
        )}
        <hr className="hr-width mtb-20" />
        <div className="align-center">
          <Icon root="common" name="time" size="small" />
          <span className="redirect-mssg">
            {' '}
            {t(d.REDIRECTMESSAGE1)} {redirectSeconds} {t(d.REDIRECTMESSAGE2)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ProgressTab;
